(function(){
    'use strict';
    angular.module('Services').service('ActionlogTableService', ActionlogTableService);
    ActionlogTableService.$inject = [
        'TableLiteFactory',
        'AdminPermissionService',
        '$routeParams',
        'toastr',
        '$filter',
        '$uibModal'
    ];

    function ActionlogTableService(
        TableLiteFactory,
        AdminPermissionService,
        $routeParams,
        toastr,
        $filter,
        $uibModal
    ){
        return function(){
            const tableData = {
                headers: [
                    {
                        label:'Date',
                        viewName:'date',
                        filterName:'createDate',
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label:'Action Log',
                        viewName:'actionLog',
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label:'Request Method',
                        viewName:'requestMethod',
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label:'Changes',
                        viewName:'changes',
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label:'Path ',
                        viewName:'path',
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        viewName: 'actions',
                        label: 'Actions',
                        filter:{
                            type:'button'
                        }
                    },
                ],
                data: []
            }

            const tableActions = new TableLiteFactory(tableData,
                {
                    serviceCallback: AdminPermissionService.Actionlog.getTeamActionsList,
                    callbackFormat: ['success', 'error', 'filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters: {
                        'auditUser.userId': $routeParams.accountId,
                        sort:'createdDate,desc'
                    }
                }
            );

            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;
            
            function buildTableData(data){
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function(item){
                        item.user={
                            type:'multiLine',
                            list:item.auditUser
                        };
                        item.actionLog=item.auditLogChange;
                        item.requestMethod = item.requestMethod || 'TRACKED';
                        let auditChanges = {};
                       
                        if(item.auditChanges){
                            for(let i =0;i < item.auditChanges.length;i++){
                                let key = item.auditChanges[i].propertyName;
                                let newValue = `${[i]} ${item.auditChanges[i].newValue}`;
                                let oldValue = `${[i]} ${item.auditChanges[i].oldValue}`;
                            
                                auditChanges[key] = `${item.auditChanges[i].propertyName.toUpperCase().bold()}:`;
                                auditChanges[newValue] =`New "${item.auditChanges[i].newValue.bold()}"`;
                                auditChanges[oldValue] = `Old "${item.auditChanges[i].oldValue.bold()}"`;
                            }
                            item.changes={
                                type:'multiLine',
                                list:auditChanges
                            };
                        }else{
                            item.changes='None'
                        }
                        
                        item.path=item.path;
                        item.date= $filter('bbaDate')(item.createdDate,'hh:mm a');
                        item.actions = {
                            type: 'button',
                            buttons:[{
                                text: 'View',
                                action:  function () {
                                    //  modal box
                                    $uibModal.open({
                                        animation: true,
                                        ariaLabelledBy: 'modal-title',
                                        ariaDescribedBy: 'modal-body',
                                        templateUrl: '/templates/pages/administration/modal/actionLogModal.html',
                                        controller: 'ActionLogModalController',
                                        controllerAs: 'vm',
                                        size: 'md',
                                        appendTo: $('body'),
                                        resolve: {
                                            data: function () {
                                                return item;
                                            }
                                        }
                                    });
                                },
                            class: 'btn-info btn-quirk btn-sm'
                            }]
                        };
                        tableData.data.push(item)
                })
            }
            this.tableData = tableData;
        }
    }
})()


// WEBPACK FOOTER //
// ./js/services/tables/administrationTable/ActionLogTableService.js